import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter, p} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: React.ComponentType<IIcon>;
    onClick?: () => void;
}

export const ReelDetailsActionButton = (props: IProps) => {
    const Icon = props.icon;

    const handleOnClick = () => {
        props.onClick?.();
    };

    return (
        <Button type="button" variant="none_secondary" onClick={handleOnClick} css={buttonStyle}>
            <Icon size="2.4" />
        </Button>
    );
};

const buttonStyle = css`
    ${p(1)};
    ${flexAbsoluteCenter};
    background-color: #fff;
    border-color: #fff;
    width: ${calculateRemSize(5)};
    height: ${calculateRemSize(5)};
    min-width: auto;
    min-height: auto;
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter, p} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: React.ComponentType<IIcon>;
    onClick?: () => void;
}

export const ReelDetailsActionButton = (props: IProps) => {
    const Icon = props.icon;

    const handleOnClick = () => {
        props.onClick?.();
    };

    return (
        <Button type="button" variant="none_secondary" onClick={handleOnClick} css={buttonStyle}>
            <Icon size="2.4" />
        </Button>
    );
};

const buttonStyle = css`
    ${p(1)};
    ${flexAbsoluteCenter};
    background-color: #fff;
    border-color: #fff;
    width: ${calculateRemSize(5)};
    height: ${calculateRemSize(5)};
    min-width: auto;
    min-height: auto;
`;
